const state = () => ({
	cvToken: '',
	mentor: false,
	isMentorCv: false,

	cvDetail: { //简历基本详情
		basic_info: {},
		format_info: {},
		submodule_info: { sections_position: [] },
	},
	backUpFormatInfo: {}, //备份简历设置数据，用作修改排版时，恢复数据

	profile: {}, //用户基本信息
	backUpProfile: {}, //用户基本信息备份，用作修改排版时，恢复数据
	works: [], //工作
	orgs: [], //工作以外经历
	edus: [], //教育
	extras: {}, //其他
	create_custom: [],
	personal_summary: [], //个人总结
	project_experience: [], //项目
	reasearch_experience: [], //研究经历
	honor: [], //荣誉
	skill_list: [], //技能
	opus: [], //作品集
	moduleKinds: {}, //模块类型

	currentInfo: { //当前编辑数据
		type: '',//works/edus模块类型
		data: {}, //当前编辑数据
		operation: '', //add/添加，edit/修改，module/增加大模块
	},
	backUpInfo: { //当前编辑备份数据
		type: '',//works/edus模块类型
		data: {}, //当前编辑数据
		operation: '', //add/添加，edit/修改，module/增加大模块
	},
	checkData: {}, // check 的数据
	readyScore: -1,
	score: 0, // 简历的分数
	wordCount: 0,  // 右上角简历字数
	suggestInfo: {}, // 建议的数据
	onePageFunction: () => {
	}, // 一页纸方法
	dealCheck: false, // 是否处理非会员check数据
	oldLineHeight: 12, // 自动一页纸之前的行高
	autoOnePage: false, // 是否一页纸
	faqOptions: [],
	resumeWidth: 415,
	isUnfold: false,
	checkCloseEditModule: false,//检查是否需要取消当前编辑状态，并返回
	openSidebarModule: { //当前要打开的模块，及打开状态
		state: false,
		type: ''
	},
  auxiliaryPackup: false,  // 初始化默认收起大牛案例，常用动词等
	editNumber: 0, // 当前编辑次数
	showScanner: false, // 显示check检查蒙版
	syncSuccess: false, // 是否同步在线简历
	saveFormDataByDialog: null, // 在确认是否更改的弹窗上面点击保存或者不保存时，切换到点击的模块
	examples: [],
	example_tags: [],
	example_options: [],
	verbs: [],
	faqs: [],
	textEditorScrollTop: false,
	isSendRequest: false ,// 是否发起请求中
	isShowJobscanGuide: false,//是否显示jobscan的引导，及样式显示
	isShowAutoWriteError: false,//当点击开启自动写简历按钮时，如果没有填写职位名称，进行error文本显示
	autoModel:  false,//是否开启自动写简历模式
	postId: '', //职位的id
	autoWriteList: [],//自动写简历内容列表
	autoWriteTotal: 0,//内容总数
	isAutoLoading: false,//加载时的loading
	isAutoTransition: false ,//切换时的动画
	hasJobscanRepor: false,//是否有报告
	jobscanResultData: {}, // 当前简历的 jobscan 报告数据
	showWordNumHint: false,//字数检查
	isShowDownloadResume: false,//是否显示下载
	emitShowDownloadResumeBox: false, //在编辑时点击下载会提示进行是否保存操作。存储一个中间变量进行事件的触发

  showJobTabCardDialog: false, // 简历编辑页 职位 tab hover 浮窗 是否显示
  showJobTabCardDialogSelf: false, // 简历编辑页 职位 tab hover 浮窗 是否显示
  showJobTabCardDialogData: {}, // 简历编辑页 职位 tab hover 浮窗 数据
  jobTabCardContentScrollY: 0, // 简历编辑页 职位 tab 内容区垂直滚动距离
  jobTabCardDialogTop: 0, //  简历编辑页 职位 tab hover 浮窗的 top 值
  jobTabCardDialogTimer: null,
  jobTabScrollActive: false, // 简历编辑页 职位 tab 搜索 input 是否吸顶

  portraitDialogVisible: false, // 上传简历头像 visible
	notWatermarkImage: '',//下载后的无水印照片
	cvPortrait: {
		cv_highlights: [],
		cv_risks: [],
		skills: []
	},    // 简历画像
	isFirstCvInfo: {//是第一份简历进行判断
		isFirst: false,
		data: {}
	},
  groupsEntryData: {},

	openResumeError: false, //是否进入简历纠错模式
	resumeErrorInfo:{ //纠错的原始数据
		remain_times: 0,
		errors: {}
	},
	resumeErrorFilterType: '', //需要过滤的类型，word / punc / miss
	filterErrorInfo: [], //简历纠错 html数据
	selectErrorInfo: { //当前选中的错误信息
		position: {
			left: 0,
			right: 0,
		},
		modelPosition: null,
		modelData: null,
		isWrap: false,
	},
	errorUuidList:[], //错误错误 uuid的顺序
	showPurchasesErrorNumber: false, //是否显示购买纠错次数弹窗
	useResumeError: false, // 使用纠错功能
	commonIndex: -1,   // 相同公司工作子经历（要插入的下标：子经历插入到那个经历之后）
	companyIsDisabled: false,   // 添加子经历公司名不允许修改
	hasWorkSubItem: false,    // 当前简历中工作经历是否有子经历
	isMyselfResume: false,   // 当前简历是否是自己的简历
	libraryState: false,   // 经历库显示状态

	//小助手弹窗
	editorHelperPopup: {
		npsFlag: false, // 是否显示nps
		showRecommendJob: false, //是否显示推荐的职位卡片
		recommendJobItem: null, //推荐的职位信息
		showWelcome: false, //是否显示欢迎语
		leaveDay: 0, // 距离上次登录时间（天）
		showBindSubscribe: false, //是否弹出关注公众号
	},
	quitResumeEditor: false, //是否退出简历编辑
	emitShowLibrary: false,   // 编辑时打开经历库是否保存操作标记
	activeTemplateStyle: {}, // 活跃的推荐模板样式

  editorMenuTipsType: null, // 简历编辑页 menu tips活跃类型

	// initial为初始，loading为加载中，over为结束
	optimizationStatus: 'initial',
	optimizationResult: ''
})

export default state
